import { useShareRetentionRateDetailReportToLeadArMutation } from "../../../../../../api/mutations/useShareRetentionRateDetailReportToLeadArMutation";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../../../services/UINotificationService";
import {
  prepareReqFilter,
  prepareReqOrder,
  prepareReqPeriod,
} from "./useReports";

export function useShareToLeadAr({ period, filter, order }) {
  const { tCommon } = useAppTranslation.Common();

  const { mutateAsync, isLoading } =
    useShareRetentionRateDetailReportToLeadArMutation({
      onError: () => {
        uiNotification.error(tCommon("error.shareToLeadAR"));
      },
      onSuccess: () => {
        uiNotification.success(tCommon("success.shareToLeadAR"));
      },
    });

  const initiate = () => {
    return mutateAsync({
      period: prepareReqPeriod(period),
      order: prepareReqOrder(order),
      filter: prepareReqFilter(filter),
      rebooked: false,
    });
  };

  return {
    initiate,
    isLoading,
  };
}
